import { Input,Button } from 'antd';
import { FilterFilled, SearchOutlined } from '@ant-design/icons';

export const getSearchFilter = (dataIndex, title) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8, width: 204 }}>
      <Input
        autoFocus
        placeholder={`Search ${title}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button type="primary" size="small" style={{width:90}} onClick={() => confirm()} icon={<SearchOutlined />}>
          Search
        </Button>
        <Button size="small" style={{width:90}} onClick={() => { clearFilters?.(); confirm(); }}>
          Reset
        </Button>
      </div>
    </div>
  ),
  filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : '' }} />,
  onFilter: (value, record) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
});

export const getDropdownFilter = (dataIndex,data) => {
  const uniqueValues = [...new Set(data.map(item => item[dataIndex]).filter(v => v))];

  return {
    filters: [
      ...uniqueValues.map(v => ({ text: v, value: v })),
      { text: 'Show Empty Only', value: '__EMPTY__' }
    ],

    onFilter: (value, record) => {
      if (value === '__EMPTY__') {
        const v = record[dataIndex];
        return v === null || v === undefined || v === '';
      }
      return record[dataIndex] === value;
    },

    filterIcon: (filtered) => (
      <FilterFilled style={{ color: filtered ? '#1890ff' : '' }} />
    )
  };
};

export const getDateSorter = (dataIndex) => ({
  sorter: (a, b) => {
    const parseDate = (str) => {
      if (!str || str === '-') return null;
      const [datePart] = str.split(', ');
      const [day, month, year] = datePart.split('/');
      return new Date(year, month - 1, day);
    };
    
    const dateA = parseDate(a[dataIndex]);
    const dateB = parseDate(b[dataIndex]);
    
    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;
    
    return dateA - dateB;
  },
  sortDirections: ['descend', 'ascend'],
});